<template>
  <div>
    <Loading v-if="isLoading('Actualizing tour details')" code="Actualizing tour details" />
    <Error v-else-if="isError()" />
    <div class="wtv-flight-error" v-if="context === 'office' && isError()">
      <div class="wtv-flight-error-paragraph">
        Не удалось получить дополнительные сведения, но Вы можете создать заявку
        и забронировать её.
      </div>
      <div class="wtv-flight-error-paragraph">
        При возможности выбора рейсов у тур. оператора сотрудники Центра
        Бронирования уточнят варианты по перелётам для данного тура и согласуют
        с вами эти варианты и цены.
      </div>
    </div>

    <div
      v-else-if="flights"
      v-for="(flight, i) in flights"
      class="wtv-flight wtv-icon"
      @click="setFlightNum(i)"
      :class="{ 'wtv-checked': flightNum === i }"
      :key="i"
    >
      <div class="wtv-flight-item wtv-icon">
        <div class="wtv-flight-company">
          {{ flight.forward[0].company.name }}
          <div class="wtv-flight-number">{{ flight.forward[0].number }}</div>
        </div>
        <div class="wtv-flight-details">
          <div class="wtv-flight-port">
            {{ flight.forward[0].departure.port.name }} -
            {{ flight.forward[0].arrival.port.name }}
          </div>
          <div class="wtv-flight-time">
            <div class="wtv-flight-date">{{ flight.forward[0].departure.date }}</div>
            {{ flight.forward[0].departure.time }} -
            {{ flight.forward[0].arrival.time }}
          </div>
        </div>
      </div>
      <div class="wtv-flight-item wtv-backward wtv-icon">
        <div class="wtv-flight-company">
          {{ flight.backward[0].company.name }}
          <div class="wtv-flight-number">{{ flight.backward[0].number }}</div>
        </div>
        <div class="wtv-flight-details">
          <div class="wtv-flight-port">
            {{ flight.backward[0].departure.port.name }} -
            {{ flight.backward[0].arrival.port.name }}
          </div>
          <div class="wtv-flight-time">
            <div class="wtv-flight-date">{{ flight.backward[0].departure.date }}</div>
            {{ flight.backward[0].departure.time }} -
            {{ flight.backward[0].arrival.time }}
          </div>
        </div>
      </div>
      <div class="wtv-flight-price">
        <div
          class="wtv-price"
          v-html="priceString(flight.price.value)"
        ></div>
        <div class="wtv-tour-fuelcharge wtv-icon">
          <div class="wtv-small">Топливный сбор</div>
          <div
            class="wtv-price"
            v-html="
              priceString(flight.fuelcharge.value)
            "
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue';
import Error from '@/components/Error.vue';
import { useStore } from 'vuex';
import { computed } from 'vue';

export default {
  name: 'Flights',
  components: {
    Loading,
    Error,
  },
  setup() {
    const $store = useStore();
    const {
      isLoading,
      isError,
      priceString,
      context,
    } = $store.getters;
    const setFlightNum = (flightNum) => $store.commit('flightNum', flightNum);
    const flightNum = computed(() => $store.state.flightNum);
    console.log($store.state);
    const flights = computed(() => $store?.state?.tour?.detail?.flights || []);

    return {
      isLoading,
      flights,
      isError,
      priceString,
      context,
      setFlightNum,
      flightNum,
    };
  },
  // computed: {
  //   ...mapState(['tour', 'flightNum']),
  //   ...mapGetters(['isLoading', 'isError', 'priceString', 'context']),

  // },
  // methods: {
  //   ...mapMutations(['setFlightNum'])
  // }

};
</script>

<style scoped>
.wtv-flight {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  border: 1px solid var(--color-alt-5);
  margin: 8px;
}
.wtv-flight:before {
  position: absolute;
  top: 4px;
  left: 4px;
  content: '\f0c8';
  font-weight: 300;
  font-size: 24px;
  color: var(--color-alt-5);
  transition: 0.1s;
}
.wtv-flight.wtv-checked {
  box-shadow: 0 0 1px var(--color-alt), 0 0 8px var(--color-bg-dark),
    1px 0 12px var(--color-bg);
}
.wtv-flight.wtv-checked:before {
  content: '\f14a';
  font-weight: 700;
  color: var(--color-alt);
  transition: 0.1s;
}
.wtv-flight:hover {
  cursor: pointer;
}
.wtv-flight-item {
  flex: 5;
  display: flex;
  align-items: center;
  padding: 8px 18px;
}
.wtv-flight-item:before {
  font-size: 24px;
  content: '\f064';
  color: var(--color-text-5);
}
.wtv-flight-item.wtv-backward:before {
  content: '\f3e5';
}
.wtv-flight-company,
.wtv-flight-details {
  padding: 8px 0 8px 18px;
}
.wtv-flight-company {
  min-width: 80px;
}
.wtv-flight-port {
  font-size: 18px;
}
.wtv-flight-number,
.wtv-flight-date {
  font-weight: 700;
}
.wtv-flight-price {
  flex: 2;
  padding: 8px 18px;
}
.wtv-tour-fuelcharge {
  padding-left: 28px;
  position: relative;
}
.wtv-tour-fuelcharge:before {
  content: '\f52f';
  font-size: 18px;
  position: absolute;
  left: 0;
  top: 24px;
}
.wtv-flight-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--color-bg);
}
.wtv-flight-error-paragraph {
  padding: 4px 18px;
  max-width: 400px;
}
</style>
